import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { tailwindConfig } from '@fuse/tailwind/tailwind-extracted-config';

@Injectable()
export class FuseTailwindService {
    private _tailwindConfig: ReplaySubject<any> = new ReplaySubject<any>(1);

    /**
     * Constructor
     */
    constructor() {
        this._tailwindConfig.next(tailwindConfig);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for _tailwindConfig
     */
    get tailwindConfig$(): Observable<any> {
        return this._tailwindConfig.asObservable();
    }
}
